import { createSelector } from 'reselect';
import { entitiesSelector } from '../common/state/selectors/issue-selector.tsx';

const loomRootSelector = createSelector(entitiesSelector, (entities) => entities.loom);

export const insertLoomLinkClickedCountSelector = createSelector(
	loomRootSelector,
	(loom) => loom.insertLoomLinkClickedCount,
);

export const isInsertLoomLinkOpenedSelector = createSelector(
	insertLoomLinkClickedCountSelector,
	(insertLoomLinkClickedCount) => insertLoomLinkClickedCount > 0,
);
